import { render, staticRenderFns } from "./miniCustom.vue?vue&type=template&id=0523c75e&scoped=true&"
import script from "./miniCustom.vue?vue&type=script&lang=js&"
export * from "./miniCustom.vue?vue&type=script&lang=js&"
import style0 from "./miniCustom.vue?vue&type=style&index=0&id=0523c75e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0523c75e",
  null
  
)

export default component.exports